module.exports = "/static/assets/2b0b532fda25919c2ea7ff2129ae9271.png";